export default "__VITE_ASSET__94fea00f__"